module.exports = __webpack_public_path__ + "static/media/ic-search.fd1b7665.svg";